import { createAction } from 'redux-actions';

export const GG_ENVIRONMENT_SET = 'GG_ENVIRONMENT_SET';

export default createAction(GG_ENVIRONMENT_SET);